import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {tko, map} from "../../../api/api-endpoints"
import year from '../../../utils/year'

const COLOR_FORMAT = 'hex'

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      onlyUpdate: false,
      showTkoOperatorSelectTable: false,
      showColorPallet: false,
      fields: {
        colorObject: null,
        color: '',
        tko_operator_id: '',
        mos: []
      },
      availableYears: {},
      tkoOperatorFields: {}
    }
  },
  destroyed () {
    // clean apo cache
    this.$store.commit('deleteEndpoints', {
      endpoints: [
        map.geoObjectModule()
      ],
      eager: 10
    })
  },
  watch: {
    tariffItems: {
      deep: true,
      handler: 'onTariffItems',
      immediate: true
    }
  },
  computed: {
    tariffItems () {
      return this.$store.getters.readUrlEndpoint(this.tariffDataUrl) || {data: []}
    }
  },
  methods: {
    onTkoOperator () {
      const tkoOpId = this.fields.tko_operator_id
      const endpoint = this.getItemOperatorEndpoint ? this.getItemOperatorEndpoint(tkoOpId) : null
      const tkoOperator = this.$store.getters.readUrlEndpoint(endpoint) || {mos: []}
      this.tkoOperatorFields = Object.assign({}, tkoOperator)

      //console.log(JSON.stringify(tkoOperator, null, " "))
      //console.log(JSON.stringify(this.tkoOperatorFields, null, " "))

      setTimeout(() => {
        return this.$refs.tkoOperator
      }, 0)
    },
    onTariffItems () {
      const availableYears = {}
      const range = year.getYearsOptions(-10, 20)

      if(this.tariffItems  && this.tariffItems.data){
        for (const model of this.tariffItems.data) {
          const modelIdKey = model.id ? 'id' : '_storeUUID'
          availableYears[model[modelIdKey]] = this.tariffItems.data
            .reduce((resRange, m) => resRange.filter(yO => model[modelIdKey] === m[modelIdKey] || yO.id !== +m.year), range)
        }
      }

      this.availableYears = Object.assign({}, availableYears)
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        this.fields.colorObject = {
          [COLOR_FORMAT]: this.item.color
        }
        
        this.update()
      } else {
        this.fields.colorObject = {
          [COLOR_FORMAT]: ''
        }
      }
    },
    update() {
      this.onTkoOperator(this.tkoOperator)
    },
    updateColor (colorObj) {
      this.$set(this.fields, 'color', colorObj[COLOR_FORMAT])
    },
    getEarlyCheckedTkoOperator () {
      return {
        default: this.fields.tko_operator_id
      }
    },
    deleteTkoOperator () {
      this.$e.confirmBox('', 'Убрать оператора?').then(() => {
        this.fields.tkoOperator = null
        this.fields.tko_operator_id = null
        this.onTkoOperator()
        this.$forceUpdate()
      })
    },
    endpointTkoOperatorList (ctx) {
      let route = {
        query: {
          'per-page': 50
        }
      }

      if (ctx.q) {
        route.query.q = ctx.q
      }

      if (ctx.paginateObj) {
        route.query = Object.assign(route.query, ctx.paginateObj)
      }

      let result = {
        url: null,
        fields: {
          name: {label: 'Название'}
        }
      }

      result.url = tko.regionalOperators(route)
      return result
    },
    tkoOperatorUpdate ($event) {
      let {checked, checkedLen, checkedModels} = $event
      this.checkedTkoOperatorLen = checkedLen
      this.checkedTkoOperator = checked
      this.checkedTkoOperatorModels = checkedModels
    },
    async saveTkoOperator () {
      if (this.$refs.tkoOperatorSelectTable) {
        try {
          let type = this.$refs.tkoOperatorSelectTable.currentListType
          this.$set(this.fields, 'tko_operator_id', this.checkedTkoOperator[type])
          this.fields.tkoOperator = this.checkedTkoOperatorModels[type][this.fields.tko_operator_id]
          this.showTkoOperatorSelectTable = false

          if (this.getItemOperatorEndpoint) {
            await this.$store.dispatch('updateUrlEndpoint', {
              endpoint: this.getItemOperatorEndpoint(+this.fields.tko_operator_id)
            })
            this.onTkoOperator()
          }
        } catch (e) {
          console.error(e)
          this.$e.errorBox(e)
        }
      }
    },
    municipalitiesUpdated () {
      const {id} = this.fields
      if(id) {
        this.$store.dispatch('updateModel', {
          url: map.apo(id),
          data: this.fields
        }).then(res => {
          if(res && res.data && res.data.mos){
            let fields = Object.assign(this.fields, res.data)
            this.$set(this.fields, fields)
          }
        }).catch(e => this.$e.errorBox(e)).finally(() => {
          this.$refs.tkoOperator.$refs.innerTable.updateTable()
        })
      } else {
        this.$refs.tkoOperator.$refs.innerTable.updateTable()
      }
    },
    onSuccess () {
      let route = this.getRedirectParams()
      let msg = this.fields.id
        ? 'Данные обновлены'
        : 'Запись сохранена'
      if (this.onlyUpdate === true) {
        this.onlyUpdate = false
        this.showOnSuccess(msg)
      } else {
        this.showOnSuccess(msg)
        setTimeout(() => {
          this.$router.push(route)
        }, 0)
      }
    }
  },
  asyncData: async function ({store, route, methods}) {
    if (methods.getItemEndpoint(route)) {
      const {data: {tko_operator_id = 0} = {}} = await store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getItemEndpoint(route)
      })

      if (tko_operator_id && methods.getItemOperatorEndpoint) {
        await store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getItemOperatorEndpoint(tko_operator_id)
        })
      }
    }
  }
}
